(function($) {
    if (!navigator.vendor.match(/apple/i)) {
        window.onload = function() {
            lax.init();

            // Add a driver that we use to control our animations
            lax.addDriver('scrollY', () => window.scrollY);

            // Add animation bindings to elements
            lax.addElements('.third_block_frame', {
                scrollY: {
                    translateY: [
                        ['elInY', 'elCenterY', 'elOutY'],
                        {
                            1920: [100, 25, -50]
                        }
                    ]
                }
            });

            // Add a driver that we use to control our animations
            lax.addDriver('scrollY', () => window.scrollY);

            // Add animation bindings to elements
            lax.addElements('.third_block_frame_second', {
                scrollY: {
                    translateY: [
                        ['elInY', 'elCenterY', 'elOutY'],
                        {
                            1920: [100, 25, -50]
                        }
                    ]
                }
            });

            // Add a driver that we use to control our animations
            lax.addDriver('scrollY', () => window.scrollY);

            // Add animation bindings to elements
            lax.addElements('.fourth_block_frame_second', {
                scrollY: {
                    translateY: [
                        ['elInY', 'elCenterY', 'elOutY'],
                        {
                            1920: [100, 25, -50]
                        }
                    ]
                }
            });

            // Add a driver that we use to control our animations
            lax.addDriver('scrollY', () => window.scrollY);

            // Add animation bindings to elements
            lax.addElements('.fifth_block_frame', {
                scrollY: {
                    translateY: [
                        ['elInY', 'elCenterY', 'elOutY'],
                        {
                            1920: [100, 25, -50]
                        }
                    ]
                }
            });

            // Add a driver that we use to control our animations
            lax.addDriver('scrollY', () => window.scrollY);

            // Add animation bindings to elements
            lax.addElements('.seventh_block_frame', {
                scrollY: {
                    translateY: [
                        ['elInY', 'elCenterY', 'elOutY'],
                        {
                            1920: [100, 25, -50]
                        }
                    ]
                }
            });

            // Add a driver that we use to control our animations
            lax.addDriver('scrollY', () => window.scrollY);

            // Add animation bindings to elements
            lax.addElements('.tenth_block_frame_first', {
                scrollY: {
                    translateY: [
                        ['elInY', 'elCenterY', 'elOutY'],
                        {
                            1920: [100, 25, -50]
                        }
                    ]
                }
            });

            // Add a driver that we use to control our animations
            lax.addDriver('scrollY', () => window.scrollY);

            // Add animation bindings to elements
            lax.addElements('.tenth_block_frame_second', {
                scrollY: {
                    translateY: [
                        ['elInY', 'elCenterY', 'elOutY'],
                        {
                            1920: [100, 25, -50]
                        }
                    ]
                }
            });

            // Add a driver that we use to control our animations
            lax.addDriver('scrollY', () => window.scrollY);

            // Add animation bindings to elements
            lax.addElements('.fourteenth_block_frame', {
                scrollY: {
                    translateY: [
                        ['elInY', 'elOutY'],
                        {
                            1920: [50, 25, -50]
                        }
                    ]
                }
            });
        };
    }
})(jQuery);

(function($) {
    AOS.init({
        startEvent: 'DOMContentLoaded',
        mirror: true
    });
})(jQuery);
